module.exports = __webpack_public_path__ + "static/img/230_TO8_1975.58bf16a.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/230_TO8_1975.jpg
// module id = sV5K
// module chunks = 0